import React, {Component} from 'react';
import { OBAlertBanner } from 'synapsefi-dev-ui';
import Header from './Header';
import Footer from './Footer';
import SwitchAndRoutes from './SwitchAndRoutes';
import ErrorBoundary from '../ErrorBoundary';
import styled from 'styled-components';
import mainStyles from './styles/main';

const LayoutContainer = styled.div`
`;

const AlertBannerContainer = styled.div`
  position: fixed;
  top: 60px;
  left: 0px;
  right: 0px;
  margin: 0 auto;
  width: 100%;
  z-index: 9000;

  .syn-dev-ui-alertBannerContainer {
    background-color: transparent;
    min-width: 980px;
    width: calc(100% - 244px);
    margin: 0 auto;
  }
`;

class Layout extends Component {
    render() {
        return (
            <LayoutContainer>
                <AlertBannerContainer>
                    <OBAlertBanner />
                </AlertBannerContainer>
                <Header />
                <ErrorBoundary>
                    <SwitchAndRoutes />
                </ErrorBoundary>
            </LayoutContainer>
        )
    }
}

export default Layout;